import { HomeOutlined, ShoppingOutlined, HeartOutlined, EnvironmentOutlined, CreditCardOutlined, BellOutlined, SettingOutlined, } from "@ant-design/icons";
import { Link } from "react-router-dom";


export const items = [
    { key: "home", icon: <HomeOutlined />, label: <Link to="/profile">Personal Information</Link> },
    { key: "orders", icon: <ShoppingOutlined />, label: <Link to="/profile/orders">My Orders</Link> },
    { key: "wishlist", icon: <HeartOutlined />, label: <Link to="/profile/wishlist">My Wishlist</Link> },
    { key: "address", icon: <EnvironmentOutlined />, label: <Link to="/profile/address">Manage Address</Link> },
    { key: "cards", icon: <CreditCardOutlined />, label: <Link to="/profile/cards">Saved Cards</Link> },
    { key: "notification", icon: <BellOutlined />, label: <Link to="/profile/notifications">Notifications</Link> },
    { key: "settings", icon: <SettingOutlined />, label: <Link to="/profile/settings">Settings</Link> },
];
